// extracted by mini-css-extract-plugin
module.exports = {"spinner":"spinner_spinner__7ebHO","rotating":"spinner_rotating__KAzf8"};